import { HOUR_PX, SLOT_MINUTES, allDayBars, clockText, dayLabel, freeBlocks, hoursText, inAllDayRow, isoDate, layoutDay, nightBands, nowWall, onDay, parseDay, snapMinutes, timeAxis, timeLabel } from '../../lib/calendar.js'
import { habitChips } from '../../lib/habits.js'
import { wallText } from '../../lib/time.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- calendar-week ---
let __fez_component_0;
{
const hourText = (minutes) => wallText(new Date(Date.UTC(2000, 0, 1, Math.floor(minutes / 60) % 24)), { hour: 'numeric' })
__fez_component_0 = class {
  PROPS = {
    days: Array,
    items: Array,
    countdowns: { type: Object, default: null },
    marks: { type: Object, default: null },
    night: Boolean,
    pending: Boolean,
    habits: { type: Array, default: null },
    on_open: { type: Function, state: true, default: () => {} },
    on_day: { type: Function, state: true, default: () => {} },
    on_plan: { type: Function, state: true, default: () => {} },
    on_create: { type: Function, state: true, default: () => {} },
    on_night: { type: Function, state: true, default: () => {} },
    on_habit: { type: Function, state: true, default: () => {} },
    on_habits: { type: Function, state: true, default: () => {} },
  }

  init() {
    this.state.now = nowWall()
    this.state.drag = null
  }

  onMount() {
    const timer = setInterval(() => (this.state.now = nowWall()), 60000)
    this.scrollToMorning()
    return () => clearInterval(timer)
  }

  onRefresh(props, changed) {
    if ('days' in changed) this.scrollToMorning()
  }

  async scrollToMorning() {
    await this.tick()
    const scroller = this.state.scroller
    if (!scroller) return
    const first = Math.min(...this.state.columns.flatMap((column) => column.boxes.map((box) => box.minutes)), 7 * 60)
    scroller.scrollTop = Math.max(0, this.state.axis.y(first) - HOUR_PX / 2)
  }

  open(key) {
    this.state.on_open(key)
  }

  // A header opens its day; in the day view it opens the day's name, circle and journal.
  day(day) {
    if (this.props.days.length > 1) this.state.on_day(day)
    else if (this.props.marks) this.state.on_plan(day)
  }

  plan(day) {
    this.state.on_plan(day)
  }

  allDay(day) {
    this.state.on_create(day, null, null, true)
  }

  toggleNight(open) {
    this.state.on_night(open)
  }

  // Minutes from midnight under the pointer, on the half hour.
  slotAt(event, column) {
    const top = column.getBoundingClientRect().top
    return snapMinutes(this.state.axis.minutes(event.clientY - top))
  }

  // Only the empty grid starts one: an event under the pointer opens instead.
  press(event, day) {
    if (event.button !== 0 || event.target !== event.currentTarget) return
    event.preventDefault()
    const at = this.slotAt(event, event.currentTarget)
    event.currentTarget.setPointerCapture(event.pointerId)
    this.state.drag = { day, anchor: at, from: at, to: at + SLOT_MINUTES, moved: false }
  }

  move(event) {
    const drag = this.state.drag
    if (!drag) return
    const at = this.slotAt(event, event.currentTarget)
    const from = Math.min(drag.anchor, at)
    const to = Math.max(drag.anchor, at) + SLOT_MINUTES
    if (from !== drag.from || to !== drag.to) this.state.drag = { ...drag, from, to, moved: true }
  }

  release() {
    const drag = this.state.drag
    if (!drag) return
    this.state.drag = null
    this.state.on_create(drag.day, drag.from, drag.moved ? drag.to : drag.from + 60, false)
  }

  cancelDrag() {
    this.state.drag = null
  }

  habit(ref, day, done) {
    this.state.on_habit(ref, day, done)
  }

  manageHabits() {
    this.state.on_habits()
  }

  beforeRender() {
    const items = this.props.items || []
    const today = isoDate(this.state.now)
    const nowMinutes = this.state.now.getUTCHours() * 60 + this.state.now.getUTCMinutes()
    this.state.single = this.props.days.length === 1
    this.state.planner = Boolean(this.props.marks)
    const laid = this.props.days.map((day) => ({ day, here: onDay(items, day), boxes: layoutDay(onDay(items, day).filter((item) => !inAllDayRow(item)), day) }))
    const habits = this.props.habits || []
    this.state.habitRow = habits.length > 0
    const axis = timeAxis({ ...nightBands(laid.flatMap((column) => column.boxes)), open: this.props.night })
    const y = (minutes) => Math.round(axis.y(minutes))
    this.state.axis = axis
    this.state.gridHeight = Math.round(axis.height)
    this.state.gridLines = Math.round(axis.lines)
    this.state.hours = axis.hours.map((hour) => ({ ...hour, top: Math.round(hour.top), label: hourText(hour.hour * 60) }))
    this.state.bands = axis.bands.map((band) => ({ ...band, top: Math.round(band.top), height: Math.round(band.height), label: `${hourText(band.from)} - ${hourText(band.to)}` }))
    this.state.nights = axis.nights.map((night) => ({ ...night, top: Math.round(night.top), height: Math.round(night.height) }))
    this.state.folds = axis.bands.length > 0 || axis.nights.length > 0
    this.state.columns = laid.map(({ day, here, boxes }) => {
      const date = parseDay(day)
      const mark = this.props.marks?.[day]
      return {
        day,
        today: day === today,
        dow: dayLabel(day, { weekday: 'short' }),
        num: date.getUTCDate(),
        label: mark?.label || '',
        circled: Boolean(mark?.circled),
        journal: Boolean(mark?.has_journal),
        habits: habitChips(habits, day, today),
        boxes: boxes.map((box) => {
          const short = box.height < 45
          const top = y(box.top)
          return {
            ...box.item,
            minutes: box.top,
            top,
            height: Math.max(y(box.top + box.height) - top - 2, 18),
            left: (box.col / box.cols) * 100,
            width: 100 / box.cols,
            time: short ? timeLabel(box.item.startAt) : `${timeLabel(box.item.startAt)} - ${timeLabel(box.item.endAt)}`,
            range: `${timeLabel(box.item.startAt)} - ${timeLabel(box.item.endAt)}`,
            short,
            multi: box.item.colors.length > 1,
          }
        }),
        // Free time from now on: today's starts at the next half hour. Nothing is free before the days' events are in.
        free: this.props.pending || day < today ? [] : freeBlocks(here, day, day === today ? Math.ceil(nowMinutes / 30) * 30 : 0).map((block) => {
          const top = y(block.from)
          return { key: block.from, top, height: y(block.to) - top - 2, length: hoursText(block.minutes), range: `${clockText(block.from)} - ${clockText(block.to)}` }
        }),
      }
    })
    const { bars, lanes } = allDayBars(items, this.props.days)
    const counts = this.props.days.map((day) => this.props.countdowns?.[day] || [])
    this.state.lanes = Math.max(lanes + Math.max(0, ...counts.map((list) => list.length)), 1)
    this.state.bars = bars.map((bar) => ({
      ...bar.item,
      column: `${bar.from + 2} / ${bar.to + 3}`,
      row: bar.lane + 1,
      before: bar.item.firstDay < this.props.days[0],
      after: bar.item.lastDay > this.props.days[this.props.days.length - 1],
    }))
    this.state.counts = counts.flatMap((list, index) => list.map((line, at) => ({ ...line, id: `${this.props.days[index]}:${line.key}`, column: index + 2, row: lanes + at + 1 })))
    const drag = this.state.drag
    this.state.ghost = drag ? { day: drag.day, top: y(drag.from), height: y(drag.to) - y(drag.from) - 2, label: `${clockText(drag.from)} - ${clockText(drag.to % (24 * 60))}` } : null
    this.state.nowTop = y(nowMinutes)
  }

  CSS = `:fez {
display:block;height:100%;.wk{height:100%;overflow-y:auto}.wk-top{position:sticky;top:0;z-index:4;background:var(--color-bg-raised)}.wk-head,.wk-allday,.wk-grid{display:grid;grid-template-columns:56px repeat(var(--days),minmax(0,1fr))}.wk-head{border-bottom:1px solid var(--color-border)}.wk-day{position:relative;display:flex;min-width:0;border-left:1px solid var(--color-border)}.wk-open{display:flex;flex:1;flex-direction:column;align-items:center;gap:2px;min-width:0;padding:var(--space-2) var(--space-1);border:0;background:transparent;color:var(--color-text-muted);font:inherit;cursor:pointer;&:hover .wk-num{background:var(--color-bg-hover)}}.wk-day.single .wk-open{display:grid;grid-template-columns:auto minmax(0,1fr);align-items:center;justify-items:start;column-gap:var(--space-3);padding:var(--space-2) calc(var(--space-3) + 32px) var(--space-2) var(--space-3);text-align:left;cursor:default;.wk-dow{grid-column:1;justify-self:center}.wk-num{grid-column:1}.wk-label{grid-column:2;grid-row:2;max-width:100%;font-size:var(--text-md)}}.wk-day.single.plannable .wk-open{cursor:pointer}.wk-dow{font-size:var(--text-xs);font-weight:var(--weight-semibold);letter-spacing:0.04em;text-transform:uppercase}.wk-num{display:grid;place-items:center;min-width:32px;height:32px;padding:0 var(--space-1);border-radius:var(--radius-full);color:var(--color-text);font-size:var(--text-lg);font-weight:var(--weight-medium);&.circled{outline:2px solid var(--color-danger);outline-offset:1px}}.wk-label{max-width:100%;overflow:hidden;color:var(--color-accent);font-size:var(--text-2xs);font-weight:var(--weight-semibold);line-height:var(--leading-tight);text-overflow:ellipsis;white-space:nowrap}.wk-day.today .wk-open{color:var(--color-accent);.wk-num,&:hover .wk-num{background:var(--color-accent);color:var(--color-accent-text)}}.wk-plan{position:absolute;top:var(--space-1);right:var(--space-1);display:grid;place-items:center;width:24px;height:24px;padding:0;border:0;border-radius:var(--radius-sm);background:transparent;color:var(--color-text-subtle);cursor:pointer;opacity:0;&:hover{background:var(--color-bg-hover);color:var(--color-text)}&:focus-visible{opacity:1;outline:2px solid var(--color-focus);outline-offset:-2px}&.on{color:var(--color-accent);opacity:1}}.wk-day:hover .wk-plan,.wk-day.single .wk-plan{opacity:1}.wk-day.single .wk-plan{top:50%;right:var(--space-3);width:28px;height:28px;transform:translateY(-50%)} :mobile {.wk-day:not(.single) .wk-plan{display:none}}.wk-allday{grid-auto-rows:22px;row-gap:2px;padding:2px 0;border-bottom:1px solid var(--color-border);background:var(--color-bg-subtle)}.wk-allday-label{grid-column:1;padding-right:var(--space-2);color:var(--color-text-subtle);font-size:var(--text-2xs);line-height:22px;text-align:right}.wk-allday-cell{margin:-2px 0;border-left:1px solid var(--color-border);cursor:pointer;&:hover{background:var(--color-bg-hover)}}.wk-chip{z-index:1;display:flex;align-items:center;min-width:0;margin:0 3px;padding:0 var(--space-2);border:0;border-radius:var(--radius-sm);background:var(--tag);color:var(--color-text-inverse);font:inherit;font-size:var(--text-xs);font-weight:var(--weight-medium);text-align:left;cursor:pointer;&.before{margin-left:0;border-top-left-radius:0;border-bottom-left-radius:0}&.after{margin-right:0;border-top-right-radius:0;border-bottom-right-radius:0}span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}}.wk-grid{position:relative}.wk-hours{position:relative}.wk-hour{position:absolute;right:var(--space-2);margin-top:-7px;color:var(--color-text-subtle);font-size:var(--text-2xs);line-height:14px;white-space:nowrap}.wk-col{position:relative;touch-action:pan-y;user-select:none;border-left:1px solid var(--color-border);background:repeating-linear-gradient(to bottom,var(--color-border) 0,var(--color-border) 1px,transparent 1px,transparent 48px);&.today{background-color:var(--color-accent-soft)}}.wk-band{position:absolute;left:0;right:0;z-index:2;display:flex;align-items:center;gap:var(--space-2);padding:0 var(--space-3) 0 calc(56px + var(--space-3));border:0;border-top:1px solid var(--color-border);border-bottom:1px solid var(--color-border);background:var(--color-bg-subtle);color:var(--color-text-muted);font:inherit;font-size:var(--text-xs);font-weight:var(--weight-medium);text-align:left;cursor:pointer;&.early{border-top:0}&:hover{background:var(--color-bg-hover);color:var(--color-text)}&:focus-visible{outline:2px solid var(--color-focus);outline-offset:-2px}}.wk-night{position:absolute;left:0;right:0;background:color-mix(in srgb,var(--color-text) 4%,transparent);pointer-events:none}.wk-corner{display:flex;align-items:flex-end;justify-content:center;padding-bottom:var(--space-1)}.wk-habits{display:grid;grid-template-columns:56px repeat(var(--days),minmax(0,1fr));border-bottom:1px solid var(--color-border)}.wk-habits-corner{display:flex;align-items:center;justify-content:center}.wk-habits-cell{min-width:0;padding:var(--space-1);border-left:1px solid var(--color-border)}.wk-free{position:absolute;left:1px;right:3px;display:flex;align-items:baseline;gap:var(--space-1);min-width:0;padding:3px var(--space-2);overflow:hidden;border-left:2px solid color-mix(in srgb,var(--color-success) 55%,transparent);border-radius:var(--radius-sm);background:color-mix(in srgb,var(--color-success) 7%,transparent);color:var(--color-success);font-size:var(--text-xs);line-height:var(--leading-tight);pointer-events:none}.wk-free-label{font-weight:var(--weight-semibold)}.wk-free-length{overflow:hidden;opacity:0.8;text-overflow:ellipsis;white-space:nowrap}.wk-count{z-index:1;display:flex;align-items:center;gap:4px;min-width:0;margin:0 3px;padding:0 var(--space-2);border:1px dashed var(--tag);border-radius:var(--radius-sm);background:var(--color-bg-raised);color:var(--color-text-muted);font:inherit;font-size:var(--text-xs);text-align:left;cursor:pointer;&:hover{color:var(--color-text)}.wk-count-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}}.wk-event{position:absolute;display:flex;flex-direction:column;gap:1px;min-width:0;padding:2px var(--space-2);overflow:hidden;border:1px solid var(--color-bg-raised);border-left:3px solid var(--tag);border-radius:var(--radius-sm);background:color-mix(in srgb,var(--tag) 16%,var(--color-bg-raised));color:var(--color-text);font:inherit;font-size:var(--text-xs);line-height:var(--leading-tight);text-align:left;cursor:pointer;&:hover{z-index:2;box-shadow:var(--shadow-md)}&.short{flex-direction:row;align-items:center;gap:var(--space-1);.wk-event-time{flex:none}}}.wk-event-title{min-width:0;overflow:hidden;font-weight:var(--weight-semibold);text-overflow:ellipsis;white-space:nowrap}.wk-event-time{overflow:hidden;color:var(--color-text-muted);text-overflow:ellipsis;white-space:nowrap}.wk-event.cancelled,.wk-chip.cancelled{opacity:0.6;.wk-event-title,span{text-decoration:line-through}}.wk-event.tentative,.wk-event.declined{border-style:dashed;border-left-style:solid;background:var(--color-bg-raised)}.wk-event.waiting{border-color:var(--color-warning);border-left-color:var(--tag)}.wk-event.ask .wk-event-title::before{content:"";display:inline-block;width:6px;height:6px;margin-right:var(--space-1);border-radius:var(--radius-full);background:var(--color-warning);vertical-align:middle}.wk-dots{display:inline-flex;gap:2px}.wk-dot{width:6px;height:6px;border-radius:var(--radius-full);background:var(--tag)}.wk-ghost{position:absolute;left:1px;right:3px;z-index:2;padding:2px var(--space-2);border:1px solid var(--color-accent);border-radius:var(--radius-sm);background:var(--color-accent-soft);color:var(--color-accent);font-size:var(--text-xs);font-weight:var(--weight-semibold);pointer-events:none}.wk-now{position:absolute;left:0;right:0;z-index:3;height:2px;background:var(--color-danger);pointer-events:none;&::before{content:"";position:absolute;top:-4px;left:-5px;width:10px;height:10px;border-radius:var(--radius-full);background:var(--color-danger)}}
}`

  HTML = `<div class="wk" fez:this="scroller" style="--days: {state.columns.length}" aria-busy={props.pending ? 'true' : null}>
<div class="wk-top">
<div class="wk-head">
<div class="wk-corner">
{#if props.night}
<ui-button variant="ghost" size="sm" icon="arrows-in-line-vertical" title="Fold the night" aria-label="Fold the night" onclick="fez.toggleNight(false)"></ui-button>
{:else if state.folds}
<ui-button variant="ghost" size="sm" icon="moon" title="Show the night hours" aria-label="Show the night hours" onclick="fez.toggleNight(true)"></ui-button>
{/if}
</div>
{#each state.columns as column}
<div class="wk-day" class:today={column.today} class:single={state.single} class:plannable={state.planner} key={column.day}>
<button type="button" class="wk-open" title={column.label || null} onclick="fez.day('{column.day}')">
<span class="wk-dow">{column.dow}</span>
<span class="wk-num" class:circled={column.circled}>{column.num}</span>
{#if column.label}<span class="wk-label">{column.label}</span>{/if}
</button>
{#if state.planner}
<button type="button" class="wk-plan" class:on={column.journal} title={column.journal ? 'Journal' : 'Name, circle or write about this day'} aria-label="{column.dow} {column.num}: name, circle and journal" onclick="fez.plan('{column.day}')"><ui-icon name="notebook" size="15"></ui-icon></button>
{/if}
</div>
{/each}
</div>
{#if state.habitRow}
<div class="wk-habits">
<div class="wk-habits-corner"><ui-button variant="ghost" size="sm" icon="sliders-horizontal" title="Habits" aria-label="Habits" onclick="fez.manageHabits()"></ui-button></div>
{#each state.columns as column}
<div class="wk-habits-cell" key={column.day}><calendar-habits :habits="column.habits" day={column.day} compact={state.single ? 'false' : 'true'} :on_check="(ref, day, done) => fez.habit(ref, day, done)"></calendar-habits></div>
{/each}
</div>
{/if}
<div class="wk-allday">
<div class="wk-allday-label" style="grid-row: 1 / span {state.lanes}">all day</div>
{#each state.columns as column, index}
<div class="wk-allday-cell" key={column.day} style="grid-column: {index + 2}; grid-row: 1 / span {state.lanes}" title="New all-day event" onclick="fez.allDay('{column.day}')"></div>
{/each}
{#each state.bars as bar}
<button type="button" class="wk-chip" class:cancelled={bar.cancelled} class:before={bar.before} class:after={bar.after} style="grid-column: {bar.column}; grid-row: {bar.row}; --tag: var(--color-avatar-{bar.color})" title={bar.title} onclick="fez.open('{bar.key}')"><span>{bar.title}</span></button>
{/each}
{#each state.counts as count}
<button type="button" class="wk-count" key={count.id} style="grid-column: {count.column}; grid-row: {count.row}; --tag: var(--color-avatar-{count.color})" title={count.text} onclick="fez.open('{count.key}')"><ui-icon name="hourglass-simple" size="12"></ui-icon><span class="wk-count-text">{count.text}</span></button>
{/each}
</div>
</div>
<div class="wk-grid">
<div class="wk-hours" style="height: {state.gridHeight}px">
{#each state.hours as hour}
<span class="wk-hour" key={hour.hour} style="top: {hour.top}px">{hour.label}</span>
{/each}
</div>
{#each state.columns as column}
<div class="wk-col" class:today={column.today} key={column.day} style="height: {state.gridHeight}px; background-position: 0 {state.gridLines}px" onpointerdown="fez.press(event, '{column.day}')" onpointermove="fez.move(event)" onpointerup="fez.release()" onpointercancel="fez.cancelDrag()">
{#each state.nights as night}
<div class="wk-night" key={night.key} style="top: {night.top}px; height: {night.height}px"></div>
{/each}
{#each column.free as free}
<div class="wk-free" key={free.key} style="top: {free.top}px; height: {free.height}px"><span class="wk-free-label">Free</span><span class="wk-free-length">{free.length}</span></div>
{/each}
{#each column.boxes as box}
<button type="button" class="wk-event" class:short={box.short} class:cancelled={box.cancelled} class:tentative={box.tentative} class:declined={box.declined} class:ask={box.needsReply} class:waiting={box.waiting} style="top: {box.top}px; height: {box.height}px; left: calc({box.left}% + 1px); width: calc({box.width}% - 3px); --tag: var(--color-avatar-{box.color})" title="{box.title}, {box.range}" onclick="fez.open('{box.key}')">
<span class="wk-event-title">{box.title}</span>
<span class="wk-event-time">{box.time}</span>
{#if box.multi}
<span class="wk-dots">{#each box.colors as color}<span class="wk-dot" style="--tag: var(--color-avatar-{color})"></span>{/each}</span>
{/if}
</button>
{/each}
{#if state.ghost && state.ghost.day === column.day}<div class="wk-ghost" style="top: {state.ghost.top}px; height: {state.ghost.height}px">{state.ghost.label}</div>{/if}
{#if column.today}
<div class="wk-now" style="top: {state.nowTop}px"></div>
{/if}
</div>
{/each}
{#each state.bands as band}
<button type="button" class="wk-band" class:early={band.key === 'early'} key={band.key} style="top: {band.top}px; height: {band.height}px" title="Show the night hours" onclick="fez.toggleNight(true)"><ui-icon name="moon" size="14"></ui-icon><span class="wk-band-text">{band.label}</span></button>
{/each}
</div>
</div>`
};
}

Fez('calendar-week', __fez_component_0);

export default __fez_component_0;
